export default __webpack_public_path__ + "static/area_3-a591bd1b79223305e8714da1c6a07fa6.jpg";